export default "__VITE_ASSET__BUHyaHIq__"